<template>
  <div class="detailedBox">
    <el-form class="detailedBoxSearch" :model="detailedSearch" ref="form" :inline="true">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="业务类型:">
            <el-select v-model="detailedSearch.type" placeholder="状态" style="width:100%;" clearable @change="getSearchDetails(1)">
              <el-option v-for="item in typeDictDate" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结算状态:">
            <el-select v-model="detailedSearch.stage" placeholder="状态" style="width:100%;" clearable @change="getSearchDetails(1)">
              <el-option v-for="item in stageData" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-input v-model="detailedSearch.orderSn" placeholder="请输入订单号搜索" @keyup.enter.native="getSearchDetails(1)"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="billExport">导出数据</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="detailedDataList" border style="width: 100%">
      <el-table-column prop="createdAt" label="时间" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.createdAt | formatDate}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="业务类型" align="center">
        <template slot-scope="scope">
          <span>{{getVal(scope.row.type)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderSn" label="订单号" align="center"></el-table-column>
      <el-table-column label="票品订单" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.orderInfo">
            {{scope.row.orderInfo.orderSn}}
          </template>
          <template v-else>
            无
          </template>
        </template>
      </el-table-column>
      <el-table-column label="结算状态" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.stage == 1 ? '已结算' : '待结算' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额（元）" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.type == 1">
            +{{scope.row.amount}}
          </template>
          <template v-else>
            -{{scope.row.amount}}
          </template>
        </template>
      </el-table-column>
    </el-table>
    <table-pagination :pageTotal="tableTotal" @handlePageChange="handlePageChange" />
  </div>
</template>

<script>
import { urlObjectParams, dateToString } from '@/utils';
import { prefix } from '@/api';
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
export default {
  data () {
    return {
      detailedSearch: {
        type: null,
        stage: null,
        orderSn: ""
      },
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      typeDictDate: [
        {
          key: null,
          value: '全部'
        }, 
        {
          key: 1,
          value: '票品收入'
        }, 
        {
          key: 2,
          value: '微信支付手续费'
        }, 
        {
          key: 3,
          value: '票品服务费'
        }, 
        {
          key: 4,
          value: '余额提现'
        }, 
        {
          key: 5,
          value: '票品收入退款'
        }
      ],
      stageData: [
        {
          key: null,
          value: '全部'
        }, {
          key: 0,
          value: '待结算'
        }, {
          key: 1,
          value: '已结算'
        }
      ]
    }
  },
  created () {
    this.getSearchDetails()
  },
  computed: {
    ...mapState({
      detailedDataList: state => state.finance.detailedDataList,
      tableTotal: state => state.finance.detailedListTotal,
      // typeDictDate: state => state.finance.typeDictDate,
      withdrawalSuccess: state => state.finance.withdrawalSuccess,
    })
  },
  watch: {
    withdrawalSuccess(val) {
      if(val) {
        this.detailedSearch = {
          type: null,
          orderSn: ""
        }
        this.getSearchDetails(1)
      }
    }
  },
  methods: {
    ...mapActions(['getDetails']),
    getSearchDetails(num) {
      this.page.pageNumber = num ? num : this.page.pageNumber
      let data = {
        ...this.detailedSearch,
        ...this.page
      }
      this.getDetails(data)
    },
    getVal(key) {
      return this.typeDictDate.find(item => item.key == key) ? this.typeDictDate.find(item => item.key == key).value : '';
    },
    handlePageChange (val) {
      this.page.pageNumber = val;
      this.getSearchDetails()
    },
    billExport () {
      let queryOptions = {
        ...this.detailedSearch
      };
      axios({
        method: 'get',
        url: `${prefix}/admin/sponsor_bill/export_excel?${urlObjectParams(queryOptions)}`,
        responseType: 'blob'
      }).then(data => {
        const blob = new Blob([data], { type: 'application/ms-excel' });
        const elink = document.createElement('a');
        elink.download = `账单明细${dateToString(new Date())}.xlsx`;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }).catch(() => {
        // this.isShowDownload = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detailedBoxSearch {
  margin-bottom: 20px;
}
</style>
